import { cn, initials } from '@/lib/utils'

/**
 * Initials on a flat brand ground — no uploads, no gravatar, no third-party
 * request. On a review the tone follows the pool, so a faculty voice reads as
 * faculty even before the badge is parsed.
 */
export function Avatar({
  displayName,
  size = 'md',
  tone = 'brand',
  className,
}: {
  displayName: string
  size?: 'sm' | 'md' | 'lg'
  tone?: 'brand' | 'faculty' | 'reader' | 'navy'
  className?: string
}) {
  const box =
    size === 'sm' ? 'size-7 text-[10px]' : size === 'lg' ? 'size-12 text-body' : 'size-9 text-meta'
  const tones = {
    brand: 'bg-itpu-light-blue text-on-brand',
    faculty: 'bg-faculty-tint text-faculty-ink',
    reader: 'bg-reader-tint text-reader-ink',
    navy: 'bg-itpu-navy text-itpu-white',
  } as const

  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-pill font-semibold',
        box,
        tones[tone],
        className,
      )}
    >
      {initials(displayName)}
    </span>
  )
}
